/**
 * Batch helpers (T10/T13). A batch is a group of candidates invited together to one
 * interview with its own exam window. Model per T0_DECISIONS §5:
 *   batch { id, exam_set_id, name, opens_at, closes_at, status }, candidates.batch_id,
 *   interview_sessions.batch_id. Status is computed by the backend; the same rule is
 *   applied here when the field is missing.
 */
import { fmtShortDate } from './derive';

export function batchStatusOf(b, now = Date.now()) {
  if (b?.status) return b.status;
  const opens = b?.opens_at ? Date.parse(b.opens_at) : NaN;
  const closes = b?.closes_at ? Date.parse(b.closes_at) : NaN;
  if (!Number.isNaN(opens) && now < opens) return 'scheduled';
  if (!Number.isNaN(closes) && now > closes) return 'closed';
  return 'open';
}

export function batchWindow(b) {
  const a = b?.opens_at ? fmtShortDate(b.opens_at) : null;
  const z = b?.closes_at ? fmtShortDate(b.closes_at) : null;
  if (a && z) return `${a} – ${z}`;
  if (a) return `From ${a}, no end date`;
  if (z) return `Until ${z}`;
  return 'No exam window';
}

/** { [examSetId]: batches sorted by open date then name } */
export function groupBatches(batches) {
  const by = {};
  (batches || []).forEach((b) => { (by[b.exam_set_id] = by[b.exam_set_id] || []).push(b); });
  Object.values(by).forEach((list) => list.sort((x, y) => (Date.parse(x.opens_at || x.created_at || 0) || 0) - (Date.parse(y.opens_at || y.created_at || 0) || 0)
    || String(x.name).localeCompare(String(y.name))));
  return by;
}

export const batchNameOf = (batchesById, id) => (id && batchesById[id] ? batchesById[id].name : '—');

/** yyyy-mm-dd for <input type="date">, offset by days from today. */
export function dateInput(offsetDays = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
